import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { MemberService } from '../../services/jrni/member.service';
import { ApiService } from '../../services/jrni/api.service';

@Component({
	selector: 'app-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
	selectedDepartment;
	pageTitle;
	calendarPageText;
	minDate;
	maxDate;
	selectedDate: Date;
	currentDate: Date;
	selectedService;
	selectedLocation;
	slots: [];
	selectedSlot;
	availableDays: any;
	component: string;
	bookingsLimit: string;
	slotSelectionError = false;

	steps = [
		{ title: 'Booking questions', isActive: false },
		{ title: 'Choose appointment date and time', isActive: true },
		{ title: 'Your details', isActive: false },
		{ title: 'Summary', isActive: false },
		{ title: 'Confirmation', isActive: false },
	];

	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private servicesService: ServicesService,
		private availabilityService: AvailabilityService,
		private alertService: AlertService,
		private basketService: BasketService,
		private translateService: TranslateService,
		private spinner: NgxSpinnerService,
		public datastoreService: DatastoreService,
		private memberService: MemberService,
		private apiService: ApiService
	) { }

	routerGoBack() {
		if (this.datastoreService.skipLocationsPage) {
			this.router.navigate(['/services']);
		} else {
			this.router.navigate(['/locations']);
		}
	}

	restartJourney() {
		if (sessionStorage.getItem('journey')) {
			this.router.navigate(['start/' + sessionStorage.getItem('journey')]);
		} else {
			this.router.navigate(['/departments']);
		}
	}

	ngOnInit() {
		this.scrollToTop();
		this.component = 'calendar';
		this.spinner.show();
		// Use this.departmentService.getLocation() if the services are set on the children departments
		// Use this.departmentService.get() if the services are set on the parent department
		this.departmentService.get().then(
			(selectedDepartment) => {
				if (selectedDepartment === undefined) {
					this.restartJourney();
				} else {
					this.selectedDepartment = selectedDepartment;
					this.departmentService
						.getLocation()
						.then(async (selectedLocation) => {
							this.selectedLocation = selectedLocation;
							if (this.datastoreService.adminJourney) {
								const adminUser: any = await this.apiService.updateLocation(selectedLocation);
								console.log('admin', adminUser);
								if (adminUser._embedded && adminUser._embedded.administrators) {
									localStorage.setItem('admin_user', JSON.stringify(adminUser._embedded.administrators[0]));
								}
							}
						});

					// this.selectedLocation = this.departmentService.getLocation();

					// Set the current date to today for the calendar to default to today
					this.currentDate = new Date();
					this.selectedDate = this.currentDate;

					// Get the configurable data
					if (this.selectedDepartment.hasOwnProperty('extra')) {
						// Set the title on the login page to the title from the business question
						this.selectedDepartment.extra.hasOwnProperty('calendar_page_title')
							? (this.pageTitle =
								this.selectedDepartment.extra.calendar_page_title)
							: (this.pageTitle = 'Calendar title not set');
						// Set the extra text on the page to the text taken from the business question
						this.selectedDepartment.extra.hasOwnProperty('calendar_page_text')
							? (this.calendarPageText =
								this.selectedDepartment.extra.calendar_page_text)
							: null;
					}

					// Retrieve the selected service
					this.servicesService.get().then((service) => {
						this.selectedService = service;

						// Clear the basket
						if (this.datastoreService.adminJourney) {
							console.log('Admin journey. Use v1');
							this.basketService
								.deleteAllBaskets(this.selectedDepartment)
								.then(async (data) => {
									this.basketService.currentBasket =
										await this.basketService.createBasket(
											this.selectedDepartment
										);
									console.log(
										'Basket created',
										this.basketService.currentBasket
									);
								})
								.catch((err) => {
									this.alertService.error(
										this.translateService.instant('COMMON.GENERAL_ERR')
									);
								});
						} else {
							const basket = this.apiService
								.createBasket(this.selectedLocation)
								.subscribe((response) => {
									if (response.headers.has('auth-token')) {
										const authToken = response.headers.get('auth-token');
										localStorage.setItem('auth_token', authToken);
										console.log(`Set auth token from basket: ${authToken}`);
									}
									this.basketService.currentBasket = response.body;
									console.log(this.basketService.currentBasket);
									this.spinner.hide();
								});
						}

						this.spinner.hide();
					});
				}
			},
			(err) => {
				this.alertService.error(
					this.translateService.instant('COMMON.GENERAL_ERR')
				);
				this.spinner.hide();
			}
		);
	}

	selectSlot(slot: any) {
		this.selectedSlot = slot;
	}

	continue() {
		this.alertService.clear();
		this.availabilityService.getSelectedSlot().then(async (slot) => {
			if (slot) {
				// now we add the item
				let resource;
				try {
					// Pass the resource id, not the whole resource object. The basket calls coerce
					// whatever they are given, but an object previously reached JRNI as
					// resource_id: null, and JRNI then silently assigns whatever resource is free at
					// that slot — booking the customer into the wrong room.
					resource = await this.availabilityService.getSelectedResource();
				} catch (err) {
					console.error(err);
					this.alertService.error(
						this.translateService.instant('COMMON.GENERAL_ERR')
					);
					this.spinner.hide();
				}
				try {
					this.spinner.show();
					if (this.datastoreService.adminJourney) {
						let staffId = null;
						if (this.datastoreService.staff_set) {
							staffId = this.datastoreService.staff_set;
						}
						console.log('Admin journey. Use v1');
						const res: any = await this.basketService.addItemV1(
							this.selectedLocation,
							this.selectedService.id,
							this.selectedService.calculated_duration,
							slot.start,
							[],
							false,
							resource,
							staffId
						);
						console.log(`Item added to basket`, res);
						this.basketService.currentBasket = res;
						this.basketService.currentServiceItem = res._embedded.items[0];
					} else {
						const serviceItem = await this.apiService.addServiceItem(
							this.selectedLocation,
							this.basketService.currentBasket,
							slot.start,
							this.selectedService,
							[],
							this.selectedService.calculated_duration,
							resource
						);
						console.log(`Item added to basket`, serviceItem);
						this.basketService.currentServiceItem = serviceItem;
					}
					this.router.navigate(['/booking-details']);
				} catch (err) {
					console.error(err);
					this.alertService.error(
						this.translateService.instant('COMMON.GENERAL_ERR')
					);
					this.spinner.hide();
				}
			} else {
				this.alertService.warn(
					this.translateService.instant('CALENDAR.SLOT_WARNING')
				);
				this.slotSelectionError = true;
				this.scrollToTop();
			}
		});
	}

	// scroll to the top of the page
	scrollToTop() {
		window.scroll(0, 0);
	}
}
